import React from "react";
import { useSelector } from "react-redux";
import { Table, Typography } from "antd";
import moment from "moment";
import commaNumber from "comma-number";
import InstitutionProfile from "../../../../components/common/InstitutionProfile";
import _ from "lodash";

const { Title, Text } = Typography;
const format = commaNumber.bindWith(",", ".");

const EmiDuePrintView = React.forwardRef((props, ref) => {
  const emiDueState = useSelector((state) => state.emiDue);
  const { list, filters, selectedCustomer } = emiDueState;

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 40 },
    { title: "EMI No", dataIndex: "emi_no", width: 80 },
    { title: "Customer Name", dataIndex: "acc_name", width: 120 },
    { title: "Contact", dataIndex: "contact_no", width: 100 },
    { 
      title: "From Date", 
      dataIndex: "from_date", 
      render: (date) => moment(date).format("YYYY-MM-DD"),
      width: 80 
    },
    { 
      title: "Last Date", 
      dataIndex: "last_date", 
      render: (date) => moment(date).format("YYYY-MM-DD"),
      width: 80 
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (val) => format(parseFloat(val || 0).toFixed(2)),
      align: "right",
      width: 80
    },
  ];

  const totalAmount = _.sumBy(list, (acc) => Number(acc.amount || 0));

  return (
    <div ref={ref} style={{ padding: 20 }}>
      <InstitutionProfile />
      
      <div style={{ textAlign: 'center', marginBottom: 20 }}>
        <Title level={3}>EMI Due List</Title>
      </div>
      
      <div style={{ marginBottom: 20 }}>
        <div style={{ float: 'left', width: '50%' }}>
          {/* <Text strong>Name: </Text>{selectedCustomer?.acc_name || ''}<br />
          <Text strong>Contact: </Text>{selectedCustomer?.contact_no || ''}<br />
          <Text strong>Address: </Text>{selectedCustomer?.address || ''} */}
        </div>
        
        <div style={{ float: 'right', width: '40%', textAlign: 'right' }}>
          <Text strong>
            Statement: {moment(filters.rawTo).format("YYYY-MM-DD")}
          </Text>
        </div>
        
        <div style={{ clear: 'both' }}></div>
      </div>
      
      <Table
        columns={columns}
        dataSource={list}
        pagination={false}
        bordered
        size="small"
        summary={() => (
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={6} align="right">
              <strong>Grand Total:</strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={6} align="right">
              <strong>{format(totalAmount.toFixed(2))}</strong>
            </Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
      
      <div style={{ marginTop: 50 }}>
        <div style={{ float: 'left', width: 150, borderTop: '1px solid #000', textAlign: 'center' }}>
          Received By
        </div>
        
        <div style={{ float: 'right', width: 150, borderTop: '1px solid #000', textAlign: 'center' }}>
          Authorized By
        </div>
        
        <div style={{ clear: 'both' }}></div>
      </div>
    </div>
  );
});

export default EmiDuePrintView;